/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Grid,
  CardActions,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment-timezone';
import { get, isEmpty, uniqueId, isNil, isNull, cloneDeep } from 'lodash';
import CancelIcon from '@material-ui/icons/Cancel';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import { VictimForm } from 'containers/CourtManagerLegalProceedings/typings';
import {
  VICTIM_FORM_INIT_STATE,
  VICTIM_QUALITY_KEYS,
} from 'containers/CourtManagerLegalProceedings/constants';
import AddVctim from 'components/SahamIcons/AddVctim';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import SahamAccordion from 'components/SahamAccordion';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import {
  VICTIM,
  EMPTY_VICTIM,
  CLAIM,
  PARTIES_CLAIM_STATUS,
  CLAIM_STATUS,
  BENEFICIARY,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import AddTransactionDrawer from 'containers/TransactionManagerTimeLine/DrawerTransaction';
import {
  CHOICE,
  GENDER,
  INJURY_POST,
  MINOR_VALUE,
} from 'containers/PreOpeningPage/constants';
import {
  checkClassVictims,
  formatVictimFromSagisBody,
  getVictimFromSagisInfo,
  oppositionVictimValue,
  checkVictimsAge,
  checkVictimAge,
  transactionVictimEligible,
  getVictimInfoById,
  formatVictimToMigration,
  shouldDisableInput,
  renderEditButtonTitle,
  renderDeleteButtonTitle,
  renderSwitchTransactionTitle,
  isManagerInTransactionInboxe,
  isUniqueCinAddedVictims,
  formatNextOfKinstoUpdate,
  ShouldShowAddVictimButton,
  displayButtonAddBeneficiary,
  displayEditBeneficiaryButton,
} from 'containers/PreOpeningPage/utils';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import VictimDrawer from 'containers/RecapManagerPage/VictimDrawer';
import { shouldDisplayEditButton } from 'containers/RecapManagerPage/utils';
import { formsAreValidated } from 'containers/services/validateForm';
import { displayErrorText } from 'containers/services/validateForm';
import { filterVisibleOnly } from 'containers/services/filters';
import { getMoroccanCities, getCity } from 'containers/RecapManagerPage/utils';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import routesHelper from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { pushTo } from 'containers/services/routes-helper';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import BeneficiaryAccordion from 'containers/PreOpeningPage/BeneficiaryAccordion';
import { Beneficiary } from 'containers/PreOpeningPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import DecisionPartiesDialog from 'containers/PreOpeningPage/DecisionPartiesDialog';
import AddVictimDrawer from 'containers/CourtManagerLegalProceedings/AddVictimsDrawer';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import {
  checkUniqCinVictim,
  isMinorVictim,
  victimValidator,
} from 'containers/PreOpeningPage/utils';
import DialogCivilProceeding from 'components/DialogCivilProceeding';
import ConfirmDialog from 'components/ConfirmDialog';
import VictimFormComponent from 'containers/CourtManagerLegalProceedings/VictimFormComponent';
import InputMask from 'react-input-mask';
import { Autocomplete as AutoComplete } from '@material-ui/lab';
import { isOtherProfession } from 'containers/CourtManagerLegalProceedings/utils';
import { OTHER_PROFESSION } from 'containers/RecapManagerPage/constants';
import warning from 'images/warning.svg';
import { VICTIM_ITT_AVAILABILITY } from 'containers/PreOpeningPage/constants';
import {
  checkClassVictim,
  isAllVictimFulledEligibility,
  isVictimEligibility,
} from 'containers/PreOpeningPage/utils';
import EligibilityTransactionDialog from 'containers/PreOpeningPage/EligibilityTransactionDialog';
import currentUserStorage from 'containers/services/security/current-user-storage';
import TitleAccordion from 'components/TitleAccordion';
import {
  removeDeletedItems,
  displayVehiclePassenger,
  removeRejectedVictims,
} from 'services/utils';
import {
  VictimContainer,
  StyledSelect,
  StyledCard,
  StyledText,
} from 'containers/PreOpeningPage/styled-component';
import {
  VictimType,
  BeneficiaryType,
  TransactionType,
} from 'typings/globalTypes';
import { getUserPrivileges } from 'helpers/utils';
export interface VictimCardProps {
  intl: IntlShape;
  victimsNumber?: number;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings: Listings;
  claimToPreopen: any;
  updateFilde?: any;
  storedClaimToPreopen: any;
  setClaimRecap?: Function;
  victimsValidation?: any;
  isRecapPage: boolean;
  isManager: boolean;
  isReadOnly: boolean;
  isOpeningManager?: boolean;
  requestUpdateVictimInfo?: Function;
  requestUpdateBeneficiaryInfo?: Function;
  policyInfo?: { sagis: {} };
  requestCreateVictim?: Function;
  requestValidateVictim?: Function;
  isLawyer?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  isCourtManager?: boolean;
  readInfoSagis?: boolean;
  sagisVictimsInfo?: any;
  isLockedPage?: boolean;
  isConversion?: boolean;
  requestClaimRecap?: Function;
  isBasicManagement?: boolean;
  resetUploadedDocument?: Function;
  uploadedDocument?: any;
  uploadDocument?: Function;
  requestAddEligibilityTransaction?: Function;
  requestAddTransaction?: Function;
  requestUpdateEligibilityTransaction?: Function;
  isCourtManagerBasicManagement?: boolean;
  location?: any;
  transactionInboxeAreaId?: any;
}

const VictimCard: React.FC<VictimCardProps> = (props): JSX.Element => {
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isPending =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.PENDING ||
    get(props.storedClaimToPreopen, 'claim.status') ===
      CLAIM_STATUS.PENDING_INFO_MODIFICATION ||
    get(props.storedClaimToPreopen, 'claim.status') ===
      CLAIM_STATUS.PENDING_APPROVAL;
  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;

  const isValidatedCorpo =
    get(props.storedClaimToPreopen, 'claim.status') ===
    CLAIM_STATUS.PENDING_APPROVAL;

  const {
    isOpeningManager,
    isCourtManager,
    isCourtMonitoringManager,
    isManagerOpeningManager,
    isTransactionManager,
    isPreOpeningManager,
  } = getUserPrivileges();

  const [saveBeneficiaryState, setSaveBeneficiaryState] = useState([
    !props.isCourtManagerBasicManagement,
  ]);

  const [expanded, setExpanded] = React.useState(true);
  const [isTransactionDrawerOpen, setIsTransactionDrawerOpen] = React.useState(
    false,
  );
  const [victimValidationState, setVictimValidationState] = React.useState({});

  const [
    isOpenConfirmTransactionDialog,
    setIsOpenConfirmTransactionDialog,
  ] = React.useState(false);
  const [
    openEligibilityTransactionDialog,
    setOpenEligibilityTransactionDialog,
  ] = React.useState(false);
  const [eligible, setEligible] = React.useState(null);
  const [reason, setReason] = React.useState(null);

  const [
    victimsEligibleToTransaction,
    setVictimsEligibleToTransaction,
  ] = React.useState<any>([]);

  const handleToggleTransactionDrawer = () => {
    setIsTransactionDrawerOpen(false);
  };
  const handleOpenTransactionDrawer = (index: any) => () => {
    setIsTransactionDrawerOpen(true);
    setVictimIndex(index);
  };
  const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : { ...props.claimToPreopen };

  const [victimIndex, setVictimIndex] = React.useState(null);
  const [openDrawerAdd, setOpenDrawerAdd] = React.useState(false);
  const [victimAddFormValues, setVictimAddFormValues] = React.useState<{
    [key: string]: VictimForm | any;
  }>({ [uniqueId()]: VICTIM_FORM_INIT_STATE });

  const addVictimCardForm = () => {
    setVictimAddFormValues(prevVictimFormValues => {
      return {
        ...prevVictimFormValues,
        [uniqueId()]: VICTIM_FORM_INIT_STATE,
      };
    });
  };

  const addVictimCardFromSagis = (sagisVictimInfo: any) => {
    setNewVictimsAddedValues((prevVictimFormValues: any) => {
      return {
        [uniqueId()]: {
          ...VICTIM_FORM_INIT_STATE,
          ...formatVictimFromSagisBody(sagisVictimInfo, props.listings, value),
        },
      } as any;
    });
  };
  const handleToggleDrawerAddVictim = () => {
    setOpenDrawerAdd(!openDrawerAdd);
  };

  const [
    isModificationDrawerOpen,
    setIsModificationDrawerOpen,
  ] = React.useState(false);

  const [openBeneficiaryForm, setOpenBeneficiaryForm] = React.useState(false);
  const [
    openDecisionPartiesDialog,
    setOpenDecisionPartiesDialog,
  ] = React.useState(false);
  const [selectedVictim, setSelectVictim] = React.useState({});

  useEffect(() => {
    const claim = { ...props.claimToPreopen };
    if (isEmpty(claim.victims) && !props.isRecapPage) {
      claim.victims.push({ ...EMPTY_VICTIM, uniqueId: uniqueId() });
      props.updateFilde && props.updateFilde(claim);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeExpanded = (
    _event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    setExpanded(expanded);
  };

  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const handleDateChange = (index: number) => (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    const { victims } = claimToPreopen;
    victims[index][VICTIM.DATE_OF_BIRTH] = moment(theDate as Date).format();

    props.updateFilde && props.updateFilde(claimToPreopen);

    return;
  };

  const handleChange = (field: string, index: number) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;
    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };
    const { victims } = claimToPreopen;
    switch (field) {
      case VICTIM.CIN:
        victims[index][VICTIM.CIN] = value;
        break;
      case VICTIM.LAST_NAME:
        victims[index][VICTIM.LAST_NAME] = value;
        break;
      case VICTIM.FIRST_NAME:
        victims[index][VICTIM.FIRST_NAME] = value;
        break;
      case VICTIM.TELEPHONE_NUMBER:
        victims[index][VICTIM.TELEPHONE_NUMBER] = value.replace(/\s+/g, '');
        break;
      case VICTIM.PROCEDURE_ID:
        victims[index][VICTIM.PROCEDURE_ID] = value;
        break;
      case VICTIM.PROFESSION:
        victims[index][VICTIM.PROFESSION] = value;
        break;
      case VICTIM.PROFESSION_TYPE:
        victims[index][VICTIM.PROFESSION_TYPE] = get(valueField, 'ItemKey');
        victims[index][VICTIM.PROFESSION] =
          get(valueField, 'ItemKey') === OTHER_PROFESSION
            ? victims[index][VICTIM.PROFESSION]
            : null;
        break;
      case VICTIM.WORK_ACCIDENT_ID:
        victims[index][VICTIM.WORK_ACCIDENT_ID] = value;
        break;
      case VICTIM.CLASS_KEY:
        victims[index][VICTIM.CLASS_KEY] = value;
        break;
      case VICTIM.ITT_AVAILABILITY:
        victims[index][VICTIM.ITT_AVAILABILITY] = value;
        victims[index][VICTIM.ITT] =
          String(value) === VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE
            ? ''
            : victims[index][VICTIM.ITT];
        break;
      case VICTIM.ITT:
        victims[index][VICTIM.ITT] =
          typeof value === 'string' ? value.replace(/[^0-9]/g, '') : value;
        break;
      case VICTIM.CITY:
        victims[index][VICTIM.CITY] = get(valueField, 'ItemKey');
        break;
      case VICTIM.VEHICLE_PASSENGER_ID:
        victims[index][VICTIM.VEHICLE_PASSENGER_ID] = value;
        break;
      case VICTIM.ADDRESS:
        victims[index][VICTIM.ADDRESS] = value;
        break;
      case VICTIM.IS_EXCLUDED:
        victims[index][VICTIM.IS_EXCLUDED] = value;
        break;
      case VICTIM.INJURY_POST_KEY:
        victims[index][VICTIM.INJURY_POST_KEY] = value;
        break;
      case VICTIM.QUALITY_KEY:
        victims[index][VICTIM.QUALITY_KEY] = value;
        if (
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE)
        ) {
          victims[index][VICTIM.IS_EXCLUDED] =
            value === VICTIM_QUALITY_KEYS.Driver ||
            value === VICTIM_QUALITY_KEYS.Subscriber
              ? CHOICE.YES
              : EMPTY_VICTIM[VICTIM.IS_EXCLUDED];
        }
        break;
      case VICTIM.OPPOSITION:
        victims[index][VICTIM.OPPOSITION] = !!(value === 1);
        break;
      case VICTIM.GENDER:
        victims[index][VICTIM.GENDER] = value;
        break;
      case VICTIM.NUMBER_OF_SPOUSE:
        victims[index][VICTIM.NUMBER_OF_SPOUSE] =
          get(victims[index], [VICTIM.GENDER], '') === GENDER.FEMALE &&
          Number(value) > 1
            ? 1
            : Number(value);
        break;
      case VICTIM.NUMBER_OF_DEPENDENTS:
        victims[index][VICTIM.NUMBER_OF_DEPENDENTS] = Number(value);
        break;
      case VICTIM.NUMBER_OF_CHILDREN:
        victims[index][VICTIM.NUMBER_OF_CHILDREN] = Number(value);
        break;
      case VICTIM.ANNUAL_INCOME:
        victims[index][VICTIM.ANNUAL_INCOME] =
          typeof value === 'string' ? value.replace(',', '.') : value;
        break;
      default:
        return claimToPreopen;
    }

    props.updateFilde && props.updateFilde(claimToPreopen);
  };

  const handleBeneficiaryChange = (
    index: number,
    beneficiary_index: number,
  ) => (beneficiary: Beneficiary) => {
    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    claimToPreopen.victims[index][VICTIM.BENEFICIARIES][
      beneficiary_index
    ] = beneficiary;
    props.updateFilde && props.updateFilde(claimToPreopen);
    saveBeneficiaryState[beneficiary_index] = true;
    setSaveBeneficiaryState(saveBeneficiaryState);
  };

  const shouldAddVictim = () => {
    const { claim, victims } = props.claimToPreopen;

    return (
      victims.length <
      parseInt(claim[CLAIM.TOTAL_INJURED_VICTIMS]) +
        parseInt(claim[CLAIM.TOTAL_DECEASED_VICTIMS])
    );
  };

  const addVictim = () => {
    const claim = { ...props.claimToPreopen };
    claim.victims.push({ ...cloneDeep(EMPTY_VICTIM), uniqueId: uniqueId() });
    props.updateFilde && props.updateFilde(claim);
  };

  const openFormBeneficiary = () => {
    setOpenBeneficiaryForm(true);
  };
  const closeFormBeneficiary = () => {
    setOpenBeneficiaryForm(false);
  };

  const saveBeneficiary = (index: number) => (beneficiary: Beneficiary) => {
    const claim = { ...value };
    claim.victims[index].beneficiaries.push(beneficiary);
    if (props.dataClaimToUpdate) {
      props.setDataClaimToUpdate &&
        props.setDataClaimToUpdate({
          ...props.dataClaimToUpdate,
          victims: get(claim, 'victims', []),
        });
    }
    if (props.setClaimRecap) {
      props.setClaimRecap({
        ...value,
        victims: get(claim, 'victims', []),
      });
    }
    closeFormBeneficiary();
    props.updateFilde && props.updateFilde(claim);
  };

  const deleteVictim = (index: number) => {
    const claim = { ...props.claimToPreopen };

    claim.victims.splice(index, 1);

    props.updateFilde && props.updateFilde(claim);
  };
  const updateByProfile = () => {
    if (isCourtMonitoringManager) {
      setOpenDrawerAdd(true);
    } else {
      routesHelper.pushTo(PAGES.PREOPENING)();
    }
  };

  const isExcludedValue = (isExcluded: boolean | string) => {
    if (props.isRecapPage && typeof isExcluded === 'boolean') {
      return isExcluded ? CHOICE.YES : CHOICE.NO;
    }
    return isExcluded;
  };

  const handleToggleModificationDrawer = (
    index: number,
    isCancel: boolean = false,
  ) => {
    if (
      !props.isManager &&
      !isCourtMonitoringManager &&
      !isRejected &&
      !props.isCourtManager
    ) {
      isOpeningManager
        ? pushTo(PAGES.OPENING_CLAIM)()
        : isCourtManager
        ? pushTo(PAGES.PREOPENING_MANAGER, {
            isFromSagis: true,
            sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
          })()
        : isPreOpeningManager
        ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
            isUsageOpening: get(props, 'location.state.isUsageOpening', false),
          })()
        : pushTo(PAGES.PREOPENING)();
    }
    setVictimIndex(index as any);
    setIsModificationDrawerOpen(!isModificationDrawerOpen);
    props.requestClaimRecap &&
      isCancel &&
      props.requestClaimRecap(get(value, 'claim.id'));
  };

  const handleEditVictim = (index: number) => (event: {
    stopPropagation: Function;
  }) => {
    event.stopPropagation();
    handleToggleModificationDrawer(index);
  };
  let value = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const victimValidation = (victim: VictimType) => {
    const victimId = victim.id ? victim.id : victim.uniqueId;
    const expectedValidationVictim = props.victimsValidation.find(
      (validation: any) => validation.id === victimId,
    );
    return expectedValidationVictim || {};
  };

  const closeVictimDrawer = () => {
    return setIsModificationDrawerOpen(false);
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);

  const errorMessage = (victim: VictimType) => {
    const expectedVictimValidation = { ...victimValidation(victim) };
    delete expectedVictimValidation.id;
    const test: any = displayErrorText(
      expectedVictimValidation,
      translateArrayErrorMessages(expectedVictimValidation, true),
    );
    return test.message;
  };

  const { victims } = value;

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });

  const successCallBackUpdateVictim = () => {
    toast.success(translate(messages.successUpdateBeneficiary, props));
  };

  const handleSubmitBeneficiaryEdit = (
    victim_index: number,
    beneficiary_index: number,
  ) => (beneficiary: any) => {
    if (props.setClaimRecap) {
      value.victims[victim_index].beneficiaries[
        beneficiary_index
      ] = beneficiary;

      props.setClaimRecap(value);
    }
    if (props.dataClaimToUpdate) {
      props.setDataClaimToUpdate &&
        props.setDataClaimToUpdate({
          ...props.dataClaimToUpdate,
          victims: get(value, 'victims', []),
        });
    }
    const decisionVictim =
      !isNull(get(value.victims[victim_index], 'decision')) &&
      get(value.victims[victim_index], 'decision.status') !==
        PARTIES_CLAIM_STATUS.VALIDATED;

    if (props.requestUpdateBeneficiaryInfo) {
      value.victims[victim_index].beneficiaries[
        beneficiary_index
      ] = beneficiary;
      props.requestUpdateBeneficiaryInfo(
        formatNextOfKinstoUpdate(
          decisionVictim,
          beneficiary,
          value,
          victim_index,
        ),
        successCallBackUpdateVictim,
      );
    }
  };

  const handleDelete = (
    victim_index: number,
    beneficiary_index: number,
  ) => () => {
    if (props.setClaimRecap) {
      const beneficiariesToDelete = value.victims[
        victim_index
      ].beneficiaries.splice(beneficiary_index, 1);
      value.victims[victim_index].beneficiariesToDelete = [
        ...beneficiariesToDelete,
      ];
      if (props.dataClaimToUpdate) {
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            victims: get(value, 'victims', []),
          });
      }
      props.setClaimRecap(value);
    } else {
      const claim = { ...props.claimToPreopen };
      claim.victims[victim_index]?.beneficiaries.splice(beneficiary_index, 1);
      props.updateFilde && props.updateFilde(claim);
    }
  };
  const handleOpenDecisionDialog = (victim: VictimType) => (_event: {
    stopPropagation: Function;
  }) => {
    setOpenDecisionPartiesDialog(true);
    setSelectVictim(victim);
  };

  const [newVictimValidation, setnNewVictimValidation] = useState({});

  const validateAddVictim = () => {
    let isFormValid = true;
    [...Object.values(newVictimsAddedValues)].forEach((el: any) => {
      const validator = victimValidator(el);
      setnNewVictimValidation(validator);
      if (!formsAreValidated(validator ? validator : {})) {
        isFormValid = false;
      }
    });
    if (isFormValid) {
      const newVictimFormValues = [...Object.values(newVictimsAddedValues)].map(
        (el: any) => {
          return { ...el, claimId: get(value, 'claim.id', '') };
        },
      );
      props.setClaimRecap &&
        props.setClaimRecap({
          ...value,
          victims: [...get(value, 'victims', []), newVictimFormValues[0]],
        });
      get(value, 'victims', []).push(newVictimFormValues[0]);
      props.setDataClaimToUpdate &&
        props.setDataClaimToUpdate({
          ...props.dataClaimToUpdate,
          victims: get(value, 'victims', []),
        });
      setIsAddVictimsDialogOpen(false);
    }
  };
  useEffect(() => {
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        victims: formatVictimToMigration(
          props.sagisVictimsInfo,
          props.readInfoSagis,
          value,
          props.listings,
          victimIndex,
        ),
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!isEmpty(props.sagisVictimsInfo), props.storedClaimToPreopen]);

  const [newVictimsAddedValues, setNewVictimsAddedValues] = useState<{
    [key: string]: VictimType;
  }>({ [uniqueId()]: VICTIM_FORM_INIT_STATE } as any);

  const addNewVictimCard = () => {
    setVictimAddFormValues(prevVictimFormValues => {
      return {
        ...prevVictimFormValues,
        [uniqueId()]: VICTIM_FORM_INIT_STATE,
      } as any;
    });
  };

  const handleDeleteVictim = (victim: VictimType) => {
    const newVictimsToAdd = victims.filter((v: any) => {
      if (!victim.id) return victim.cin !== v.cin;
      return victim.id !== v.id;
    });
    const foundVictim = victims.find((v: any) => v.cin === victim.cin);
    foundVictim.isDeleted = true;
    props.setClaimRecap &&
      props.setClaimRecap({
        ...value,
        victims: [...newVictimsToAdd, foundVictim],
      });
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        victims: [...newVictimsToAdd, foundVictim],
      });
  };

  const [isAddVictimsDialogOpen, setIsAddVictimsDialogOpen] = useState<boolean>(
    false,
  );
  const showAddVictimButton = ShouldShowAddVictimButton(
    isRejected,
    isPending,
    isValidated,
    isValidatedCorpo,
    props.isConversion,
    props.isLawyer,
    props.isLockedPage,
    props.isCourtManager,
  );

  const handleAddVictimDialog = (victim: VictimType) => (_event: {
    stopPropagation: Function;
  }) => {
    addVictimCardFromSagis(victim);
    setIsAddVictimsDialogOpen(true);
  };
  const showButtonConfirmEligibiltyTransaction =
    props.isRecapPage &&
    !props.isLockedPage &&
    isManagerInTransactionInboxe(
      get(props.transactionInboxeAreaId, 'transactionInboxeAreaId'),
    ) &&
    isTransactionManager &&
    featureService.hasFeature(FEATURES.TRANSACTION) &&
    isVictimEligibility(
      removeDeletedItems([
        ...(!isEmpty(get(props.dataClaimToUpdate, 'victims', []))
          ? get(props.dataClaimToUpdate, 'victims', [])
          : victims),
      ]),
    );

  const handleConfirmEligibiltyTransaction = () => {
    setIsOpenConfirmTransactionDialog(true);
  };

  const addVictimsEligibleToTransaction = (victim: VictimType) => () => {
    setOpenEligibilityTransactionDialog(true);
    setSelectVictim(victim);
  };

  const handleValidateEligibilityDialog = () => {
    if (isEmpty(get(selectedVictim, 'eligibilityTransaction', []))) {
      setVictimsEligibleToTransaction([
        ...victimsEligibleToTransaction,
        ...[{ ...selectedVictim, eligible, reason }],
      ]);
      setOpenEligibilityTransactionDialog(false);
      setEligible(null);
      setReason(null);
    } else if (
      !isEmpty(get(selectedVictim, 'eligibilityTransaction', [])) &&
      props.requestUpdateEligibilityTransaction
    ) {
      props.requestUpdateEligibilityTransaction(
        {
          victims: [
            {
              victimId: get(selectedVictim, 'id'),
              eligibility: eligible === CHOICE.YES ? true : false,
              reason: reason,
              id: get(selectedVictim, 'eligibilityTransaction.[0].id', []),
              claimId: get(selectedVictim, 'claimId'),
              decidedBy: currentUserStorage.get().username,
            },
          ],
          claimId: get(selectedVictim, 'claimId'),
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          username: currentUserStorage.get().username,
        },
        successCallbackUpdateEligibilityTransaction,
      );
    }
  };

  const successCallbackTransaction = () => {
    toast.success(translate(messages.successEligibility, props));
    setIsOpenConfirmTransactionDialog(false);
    setVictimsEligibleToTransaction([]);
  };

  const successCallbackUpdateEligibilityTransaction = () => {
    toast.success(translate(messages.successEligibility, props));
    setOpenEligibilityTransactionDialog(false);
    setEligible(null);
    setReason(null);
  };

  const handleValidateEligibility = (claimId: number) => () => {
    if (props.requestAddEligibilityTransaction) {
      props.requestAddEligibilityTransaction(
        {
          victims: victimsEligibleToTransaction.map((el: any) => ({
            victimId: el.id,
            eligibility: el.eligible === CHOICE.YES ? true : false,
            reason: el.reason,
            claimId: claimId,
            decidedBy: currentUserStorage.get().username,
          })),
          claimId: claimId,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          username: currentUserStorage.get().username,
        },
        successCallbackTransaction,
      );
    }
  };

  return (
    <VictimContainer className="container">
      <Card>
        <CardContent>
          <CardActions className="victim-bloc-header">
            <Typography className="victim-bloc-title">
              {translate({ ...messages.victimCardTitle }, props)}
            </Typography>
            {showAddVictimButton && (
              <PrimaryButton
                onClick={() =>
                  isOpeningManager &&
                  featureService.hasFeature(
                    FEATURES.UPDATE_CLAIM_OPENING_MANAGER,
                  )
                    ? setOpenDrawerAdd(true)
                    : setIsAddVictimsDialogOpen(true)
                }
                title={translate({ ...messages.addVictimBtn }, props)}
              />
            )}
            {isCourtMonitoringManager && !props.isLockedPage && (
              <SecondaryButton
                onClick={updateByProfile}
                title={translate({ ...messages.addVictimBtn }, props)}
              />
            )}
          </CardActions>
          {featureService.hasFeature(FEATURES.TRANSACTION) &&
            isTransactionManager &&
            transactionVictimEligible(
              removeDeletedItems([
                ...(!isEmpty(get(props.dataClaimToUpdate, 'victims', []))
                  ? removeRejectedVictims(
                      get(props.dataClaimToUpdate, 'victims', []),
                    )
                  : removeRejectedVictims(victims)),
              ]),
            ) && (
              <Card style={StyledCard} elevation={0}>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs>
                    <img src={warning} alt="warning" />
                  </Grid>
                  <Grid item>
                    <Typography style={StyledText}>
                      {translate(
                        { ...messages.warningEligibilityVictimsTitle },
                        props,
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            )}
          <div className="victims">
            {removeDeletedItems([
              ...(!isEmpty(get(props.dataClaimToUpdate, 'victims', []))
                ? get(props.dataClaimToUpdate, 'victims', [])
                : victims),
            ]).map((victim: VictimType, index: number, total: any) => {
              return (
                <div key={victim.id ? victim.id : victim.uniqueId}>
                  <SahamAccordion
                    expanded={expanded}
                    onChange={handleChangeExpanded}
                    deleteButtonTitle={renderDeleteButtonTitle(
                      props,
                      victim,
                      isRejected,
                      isValidated,
                      isValidatedCorpo,
                    )}
                    addButtonTittle={
                      victim?.isFromSagis && !props.isLockedPage
                        ? translate(messages.addTitle, props)
                        : undefined
                    }
                    addButtonOnclick={
                      victim?.isFromSagis && !props.isLockedPage
                        ? handleAddVictimDialog(victim)
                        : undefined
                    }
                    deleteButtonOnClick={() => handleDeleteVictim(victim)}
                    title={
                      <TitleAccordion
                        isTransactionManager={isTransactionManager}
                        index={index}
                        victimsEligibleToTransaction={
                          victimsEligibleToTransaction
                        }
                        isManager={
                          isCourtMonitoringManager ||
                          isOpeningManager ||
                          isCourtManager ||
                          isTransactionManager
                        }
                        victim={victim}
                      />
                    }
                    editButtonTitle={renderEditButtonTitle(
                      props,
                      isManagerOpeningManager,
                      victim,
                      isValidated,
                      isRejected,
                      value,
                      isValidatedCorpo,
                    )}
                    editButtonOnClick={
                      isManagerOpeningManager &&
                      get(victim, 'decision.status', '') ===
                        PROCEDURE_STATUSES.PENDING
                        ? handleOpenDecisionDialog(victim)
                        : handleEditVictim(index)
                    }
                    EditTransactionButtonOnClick={
                      isTransactionManager &&
                      !props.isLockedPage &&
                      !isValidatedCorpo &&
                      !isEmpty(get(victim, 'victimKey', '')) &&
                      !isNil(get(victim, 'victimKey', null)) &&
                      featureService.hasFeature(FEATURES.TRANSACTION) &&
                      !isEmpty(get(victim, 'eligibilityTransaction', []))
                        ? addVictimsEligibleToTransaction(victim)
                        : undefined
                    }
                    EditTransactionButtonTitle={
                      isTransactionManager &&
                      !props.isLockedPage &&
                      !isValidatedCorpo &&
                      featureService.hasFeature(FEATURES.TRANSACTION) &&
                      !isEmpty(get(victim, 'victimKey', '')) &&
                      !isNil(get(victim, 'victimKey', null)) &&
                      !isEmpty(get(victim, 'eligibilityTransaction', [])) &&
                      isEmpty(get(victim, 'transactions', []))
                        ? translate(
                            { ...messages.updateEligibilityTitle },
                            props,
                          )
                        : undefined
                    }
                    switchTransactionButtonTitle={renderSwitchTransactionTitle(
                      props,
                      isTransactionManager,
                      victim,
                      victimsEligibleToTransaction,
                    )}
                    switchTransactionButtonOnClick={
                      isTransactionManager &&
                      !isEmpty(get(victim, 'victimKey', '')) &&
                      !isNil(get(victim, 'victimKey', null))
                        ? isEmpty(get(victim, 'eligibilityTransaction', []))
                          ? addVictimsEligibleToTransaction(victim)
                          : handleOpenTransactionDrawer(index)
                        : undefined
                    }
                  >
                    <div className="victim-container">
                      {!props.isCourtManagerBasicManagement &&
                        !props.isRecapPage &&
                        total.length > 1 && (
                          <div className="victime-title-div">
                            <div
                              className="delete-victime"
                              onClick={() => deleteVictim(index)}
                            >
                              <CancelIcon className="delete-icon" />
                              <Typography className="delete-title">
                                {translate(
                                  { ...messages.victimDeleteButtonTitle },
                                  props,
                                )}
                              </Typography>
                            </div>
                          </div>
                        )}
                      <Grid container direction="row" spacing={2}>
                        <Grid item xs={3} className="grid-input">
                          <FormControl
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.INJURY_POST_KEY,
                                  ])
                                : false
                            }
                            fullWidth
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-procedure"
                              shrink={props.inputLabelProps}
                            >
                              {translate(
                                { ...messages.victimInjuryPostKey },
                                props,
                              )}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.INJURY_POST_KEY}
                              value={
                                get(victim, [VICTIM.INJURY_POST_KEY], '') ===
                                INJURY_POST.INJURED[1]
                                  ? INJURY_POST.INJURED[0]
                                  : get(victim, [VICTIM.INJURY_POST_KEY], '')
                              }
                              onChange={handleChange(
                                VICTIM.INJURY_POST_KEY,
                                index,
                              )}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, [VICTIM.INJURY_POST_KEY], null),
                              )}
                            >
                              {!isEmpty(get(props.listings, 'prejudice', [])) &&
                                props
                                  .listings!.prejudice.filter(
                                    (el: any) =>
                                      el.ItemKey !== INJURY_POST.INJURED[1],
                                  )
                                  .map(e => (
                                    <MenuItem value={e.ItemKey} key={e.ItemKey}>
                                      {get(
                                        e.ItemDescription.split(' '),
                                        '[0]',
                                        '',
                                      )}
                                    </MenuItem>
                                  ))}
                            </StyledSelect>

                            {!props.isRecapPage &&
                              !!get(
                                props.victimsValidation[
                                  victim.id ? victim.id : victim.uniqueId
                                ],
                                [VICTIM.INJURY_POST_KEY],
                              ) && (
                                <FormHelperText className="errorSelect">
                                  {!props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.INJURY_POST_KEY
                                      ]
                                    : ''}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <TextField
                            label={translate({ ...messages.victimCin }, props)}
                            fullWidth
                            name={VICTIM.CIN}
                            value={get(victim, [VICTIM.CIN])}
                            onChange={handleChange(VICTIM.CIN, index)}
                            InputProps={{
                              ...props.inputProps,
                            }}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'CIN', null),
                              undefined,
                              true,
                            )}
                            InputLabelProps={{
                              shrink: props.inputLabelProps,
                            }}
                            error={
                              !props.isRecapPage
                                ? (checkUniqCinVictim(
                                    [
                                      ...(!isEmpty(
                                        get(
                                          props.dataClaimToUpdate,
                                          'victims',
                                          [],
                                        ),
                                      )
                                        ? get(
                                            props.dataClaimToUpdate,
                                            'victims',
                                            [],
                                          )
                                        : victims),
                                    ],
                                    get(victim, [VICTIM.CIN]),
                                    !isNil(get(victim, 'id', null))
                                      ? get(victim, 'id', null)
                                      : victim.uniqueId,
                                    get(claimToPreopen, 'claim.lossDate'),
                                  ) &&
                                    !isMinorVictim(
                                      victim,
                                      get(claimToPreopen, 'claim.lossDate'),
                                    )) ||
                                  !!get(victimValidation(victim), [VICTIM.CIN])
                                : false
                            }
                            helperText={
                              !props.isRecapPage
                                ? checkUniqCinVictim(
                                    [
                                      ...(!isEmpty(
                                        get(
                                          props.dataClaimToUpdate,
                                          'victims',
                                          [],
                                        ),
                                      )
                                        ? get(
                                            props.dataClaimToUpdate,
                                            'victims',
                                            [],
                                          )
                                        : victims),
                                    ],
                                    get(victim, [VICTIM.CIN]),
                                    !isNil(get(victim, 'id', null))
                                      ? get(victim, 'id', null)
                                      : victim.uniqueId,
                                    get(claimToPreopen, 'claim.lossDate'),
                                  ) &&
                                  !isMinorVictim(
                                    victim,
                                    get(claimToPreopen, 'claim.lossDate'),
                                  )
                                  ? translate(messages.errorCinVictim, props)
                                  : errorMessage(victimValidation(victim))[
                                      VICTIM.CIN
                                    ]
                                : ''
                            }
                          ></TextField>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <TextField
                            label={translate(
                              { ...messages.victimLastName },
                              props,
                            )}
                            fullWidth
                            name={VICTIM.LAST_NAME}
                            value={get(victim, [VICTIM.LAST_NAME])}
                            onChange={handleChange(VICTIM.LAST_NAME, index)}
                            InputProps={props.inputProps}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'victimLastName', null),
                            )}
                            InputLabelProps={{
                              shrink: props.inputLabelProps,
                            }}
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.LAST_NAME,
                                  ])
                                : false
                            }
                            helperText={
                              !props.isRecapPage
                                ? errorMessage(victimValidation(victim))[
                                    VICTIM.LAST_NAME
                                  ]
                                : ''
                            }
                          ></TextField>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <TextField
                            label={translate(
                              { ...messages.victimFirstName },
                              props,
                            )}
                            InputProps={props.inputProps}
                            name={VICTIM.FIRST_NAME}
                            value={get(victim, [VICTIM.FIRST_NAME])}
                            onChange={handleChange(VICTIM.FIRST_NAME, index)}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'victimFirstName', null),
                            )}
                            InputLabelProps={{
                              shrink: props.inputLabelProps,
                            }}
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.FIRST_NAME,
                                  ])
                                : false
                            }
                            helperText={
                              !props.isRecapPage
                                ? errorMessage(victimValidation(victim))[
                                    VICTIM.FIRST_NAME
                                  ]
                                : ''
                            }
                            fullWidth
                          ></TextField>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={frLocale}
                          >
                            <KeyboardDatePicker
                              autoOk
                              fullWidth
                              variant="inline"
                              invalidDateMessage={
                                !props.isRecapPage
                                  ? !!get(victimValidation(victim), [
                                      VICTIM.DATE_OF_BIRTH,
                                    ])
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.DATE_OF_BIRTH
                                      ]
                                    : victim[VICTIM.DATE_OF_BIRTH] ===
                                      'Invalid date'
                                    ? translate(
                                        { ...messages.invalidDate },
                                        props,
                                      )
                                    : ''
                                  : ''
                              }
                              format="dd/MM/yyyy"
                              id="date-picker-inline-victim-date-of-birth"
                              label={translate(
                                { ...messages.victimDateOfBirth },
                                props,
                              )}
                              name={VICTIM.DATE_OF_BIRTH}
                              value={dateStringToLocalDate(
                                victim[VICTIM.DATE_OF_BIRTH] === 'Invalid date'
                                  ? ''
                                  : victim[VICTIM.DATE_OF_BIRTH],
                              )}
                              onChange={handleDateChange(index)}
                              InputProps={props.inputProps}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, [VICTIM.DATE_OF_BIRTH], null),
                              )}
                              InputLabelProps={{
                                shrink: props.inputLabelProps,
                              }}
                              error={
                                !props.isRecapPage
                                  ? !!get(victimValidation(victim), [
                                      VICTIM.DATE_OF_BIRTH,
                                    ]) ||
                                    victim[VICTIM.DATE_OF_BIRTH] ===
                                      'Invalid date' ||
                                    checkVictimAge(
                                      victim[VICTIM.DATE_OF_BIRTH],
                                      get(claimToPreopen, 'claim.lossDate'),
                                    )
                                  : false
                              }
                              helperText={
                                !props.isRecapPage
                                  ? victim[VICTIM.DATE_OF_BIRTH] ===
                                    'Invalid date'
                                    ? translate(
                                        { ...messages.invalidDate },
                                        props,
                                      )
                                    : checkVictimAge(
                                        victim[VICTIM.DATE_OF_BIRTH],
                                        get(claimToPreopen, 'claim.lossDate'),
                                      )
                                    ? translate(
                                        messages.birthDateValidation,
                                        props,
                                      )
                                    : errorMessage(victimValidation(victim))[
                                        VICTIM.DATE_OF_BIRTH
                                      ]
                                  : ''
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <InputMask
                            mask="9999 999 999"
                            value={get(victim, [VICTIM.TELEPHONE_NUMBER])}
                            onChange={handleChange(
                              VICTIM.TELEPHONE_NUMBER,
                              index,
                            )}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'victimPhoneNumber', null),
                            )}
                          >
                            {() => (
                              <TextField
                                label={translate(
                                  { ...messages.victimTelephone },
                                  props,
                                )}
                                fullWidth
                                disabled={shouldDisableInput(
                                  props.disableInput,
                                  props.isCourtManagerBasicManagement,
                                  get(victim, 'victimPhoneNumber', null),
                                )}
                                error={
                                  !props.isRecapPage
                                    ? !!get(victimValidation(victim), [
                                        VICTIM.TELEPHONE_NUMBER,
                                      ])
                                    : false
                                }
                                helperText={
                                  !props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.TELEPHONE_NUMBER
                                      ]
                                    : ''
                                }
                              ></TextField>
                            )}
                          </InputMask>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <FormControl
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.QUALITY_KEY,
                                  ])
                                : false
                            }
                            fullWidth
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-procedure"
                              shrink={props.inputLabelProps}
                            >
                              {translate(
                                { ...messages.victimQualityKey },
                                props,
                              )}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.QUALITY_KEY}
                              value={get(victim, [VICTIM.QUALITY_KEY], '')}
                              onChange={handleChange(VICTIM.QUALITY_KEY, index)}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, 'qualityVictim', null),
                              )}
                            >
                              {!isEmpty(
                                get(props.listings, 'qualityOfVictim', []),
                              ) &&
                                props.listings!.qualityOfVictim.map(
                                  classItem => (
                                    <MenuItem
                                      value={classItem.ItemKey}
                                      key={classItem.ItemKey}
                                    >
                                      {classItem.ItemDescription}
                                    </MenuItem>
                                  ),
                                )}
                            </StyledSelect>
                            {!props.isRecapPage &&
                              !!get(
                                props.victimsValidation[
                                  victim.id ? victim.id : victim.uniqueId
                                ],
                                [VICTIM.QUALITY_KEY],
                              ) && (
                                <FormHelperText className="errorSelect">
                                  {!props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.QUALITY_KEY
                                      ]
                                    : ''}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        {displayVehiclePassenger(victim) && (
                          <Grid item xs={3} className="grid-input">
                            <FormControl
                              error={
                                !props.isRecapPage
                                  ? !!get(victimValidation(victim), [
                                      VICTIM.VEHICLE_PASSENGER_ID,
                                    ])
                                  : false
                              }
                              fullWidth
                            >
                              <InputLabel
                                ref={inputLabel}
                                id="simple-select-outlined-label-procedure"
                                shrink={props.inputLabelProps}
                              >
                                {translate(
                                  { ...messages.vehiclePassenger },
                                  props,
                                )}
                              </InputLabel>
                              <StyledSelect
                                name={VICTIM.VEHICLE_PASSENGER_ID}
                                value={get(
                                  victim,
                                  [VICTIM.VEHICLE_PASSENGER_ID],
                                  '',
                                )}
                                onChange={handleChange(
                                  VICTIM.VEHICLE_PASSENGER_ID,
                                  index,
                                )}
                                disabled={shouldDisableInput(
                                  props.disableInput,
                                  props.isCourtManagerBasicManagement,
                                  get(
                                    victim,
                                    [VICTIM.VEHICLE_PASSENGER_ID],
                                    null,
                                  ),
                                )}
                              >
                                {get(
                                  props.listings,
                                  'vehiclePassenger',
                                  [],
                                ).map((classItem: any) => (
                                  <MenuItem
                                    value={classItem.id}
                                    key={classItem.id}
                                  >
                                    {classItem.title}
                                  </MenuItem>
                                ))}
                              </StyledSelect>
                              {!props.isRecapPage &&
                                !!get(
                                  props.victimsValidation[
                                    victim.id ? victim.id : victim.uniqueId
                                  ],
                                  [VICTIM.VEHICLE_PASSENGER_ID],
                                ) && (
                                  <FormHelperText className="errorSelect">
                                    {!props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.VEHICLE_PASSENGER_ID
                                        ]
                                      : ''}
                                  </FormHelperText>
                                )}
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item xs={3} className="grid-input">
                          <FormControl
                            fullWidth
                            error={
                              !props.isRecapPage
                                ? checkClassVictim(
                                    get(victim, [VICTIM.DATE_OF_BIRTH]),
                                    get(claimToPreopen, 'claim.lossDate'),
                                    get(victim, [VICTIM.CLASS_KEY]),
                                  )
                                  ? checkClassVictim(
                                      get(victim, [VICTIM.DATE_OF_BIRTH]),
                                      get(claimToPreopen, 'claim.lossDate'),
                                      get(victim, [VICTIM.CLASS_KEY]),
                                    )
                                  : !!get(victimValidation(victim), [
                                      VICTIM.CLASS_KEY,
                                    ])
                                : false
                            }
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-class"
                              shrink={props.inputLabelProps}
                            >
                              {translate({ ...messages.class }, props)}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.CLASS_KEY}
                              value={get(victim, [VICTIM.CLASS_KEY])}
                              onChange={handleChange(VICTIM.CLASS_KEY, index)}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, 'classVictim', null),
                                get(victim, 'classVictim', null) === 0,
                              )}
                              labelWidth={130}
                            >
                              {!isEmpty(
                                get(props.listings, 'classVictim', []),
                              ) &&
                                props.listings!.classVictim.map(classItem => (
                                  <MenuItem
                                    value={classItem.ItemKey}
                                    key={classItem.ItemKey}
                                  >
                                    {classItem.ItemDescription}
                                  </MenuItem>
                                ))}
                            </StyledSelect>
                            {!props.isRecapPage &&
                              (!!get(
                                props.victimsValidation[
                                  victim.id ? victim.id : victim.uniqueId
                                ],
                                [VICTIM.CLASS_KEY],
                              ) ||
                                checkClassVictim(
                                  get(victim, [VICTIM.DATE_OF_BIRTH]),
                                  get(claimToPreopen, 'claim.lossDate'),
                                  get(victim, [VICTIM.CLASS_KEY]),
                                )) && (
                                <FormHelperText className="errorSelect">
                                  {!props.isRecapPage
                                    ? checkClassVictim(
                                        get(victim, [VICTIM.DATE_OF_BIRTH]),
                                        get(claimToPreopen, 'claim.lossDate'),
                                        get(victim, [VICTIM.CLASS_KEY]),
                                      )
                                      ? translate(
                                          messages.classKeyValidation,
                                          props,
                                        )
                                      : errorMessage(victimValidation(victim))[
                                          VICTIM.CLASS_KEY
                                        ]
                                    : ''}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl
                            fullWidth
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.GENDER,
                                  ])
                                : false
                            }
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-procedure"
                              shrink={props.inputLabelProps}
                            >
                              {translate({ ...messages.sexe }, props)}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.GENDER}
                              value={get(victim, [VICTIM.GENDER], '')}
                              onChange={handleChange(VICTIM.GENDER, index)}
                              disabled={props.disableInput}
                              labelWidth={230}
                            >
                              <MenuItem value={GENDER.MALE} key={0}>
                                {GENDER.MALE}
                              </MenuItem>
                              <MenuItem value={GENDER.FEMALE} key={1}>
                                {GENDER.FEMALE}
                              </MenuItem>
                            </StyledSelect>
                            {!props.isRecapPage &&
                              !!get(victimValidation(victim), [
                                VICTIM.GENDER,
                              ]) && (
                                <FormHelperText className="errorSelect">
                                  {
                                    errorMessage(victimValidation(victim))[
                                      VICTIM.GENDER
                                    ]
                                  }
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <FormControl
                            fullWidth
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.PROCEDURE_ID,
                                  ])
                                : false
                            }
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-procedure"
                              shrink={props.inputLabelProps}
                            >
                              {translate({ ...messages.typeProcedure }, props)}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.PROCEDURE_ID}
                              value={get(victim, [VICTIM.PROCEDURE_ID], '')}
                              onChange={handleChange(
                                VICTIM.PROCEDURE_ID,
                                index,
                              )}
                              disabled={props.disableInput}
                            >
                              {!isEmpty(
                                get(props.listings, 'procedures', []),
                              ) &&
                                filterVisibleOnly(
                                  props.listings!.procedures,
                                ).map(procedure => (
                                  <MenuItem
                                    value={procedure.id}
                                    key={procedure.id}
                                  >
                                    {procedure.title}
                                  </MenuItem>
                                ))}
                            </StyledSelect>
                            {!props.isRecapPage &&
                              !!get(victimValidation(victim), [
                                VICTIM.PROCEDURE_ID,
                              ]) && (
                                <FormHelperText className="errorSelect">
                                  {
                                    errorMessage(victimValidation(victim))[
                                      VICTIM.PROCEDURE_ID
                                    ]
                                  }
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={3} className="grid-input">
                          <FormControl fullWidth>
                            <AutoComplete
                              fullWidth
                              options={get(props.listings, 'Profession', [])}
                              getOptionLabel={(option: any) =>
                                `${
                                  option?.ItemDescription
                                    ? option?.ItemDescription
                                    : ''
                                }`
                              }
                              value={
                                (get(props.listings, 'Profession', []).find(
                                  (item: any) =>
                                    item.ItemKey ===
                                    get(victim, VICTIM.PROFESSION_TYPE),
                                ) || {}) as any
                              }
                              onChange={
                                handleChange(
                                  VICTIM.PROFESSION_TYPE,
                                  index,
                                ) as any
                              }
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, 'victimProfessionCode'),
                                get(victim, 'victimProfessionCode') != 0,
                              )}
                              renderInput={(params: any) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label={translate(
                                    messages.professionType,
                                    props,
                                  )}
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.PROFESSION_TYPE,
                                        ])
                                      : false
                                  }
                                  helperText={
                                    !props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.PROFESSION_TYPE
                                        ]
                                      : ''
                                  }
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        {isOtherProfession(
                          get(props.listings, 'Profession', []),
                          get(victim, [VICTIM.PROFESSION_TYPE]),
                        ) && (
                          <Grid item xs={3}>
                            <TextField
                              label={translate(
                                { ...messages.profession },
                                props,
                              )}
                              fullWidth
                              InputProps={props.inputProps}
                              disabled={props.disableInput}
                              name={VICTIM.PROFESSION}
                              value={get(victim, [VICTIM.PROFESSION])}
                              onChange={handleChange(VICTIM.PROFESSION, index)}
                              InputLabelProps={{
                                shrink: props.inputLabelProps,
                              }}
                              error={
                                !props.isRecapPage
                                  ? !!get(victimValidation(victim), [
                                      VICTIM.PROFESSION,
                                    ])
                                  : false
                              }
                              helperText={
                                !props.isRecapPage
                                  ? errorMessage(victimValidation(victim))[
                                      VICTIM.PROFESSION
                                    ]
                                  : ''
                              }
                            ></TextField>
                          </Grid>
                        )}
                        <Grid item xs={3}>
                          <FormControl
                            fullWidth
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.WORK_ACCIDENT_ID,
                                  ])
                                : false
                            }
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-work-accident"
                              shrink={props.inputLabelProps}
                            >
                              {translate({ ...messages.workAccident }, props)}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.WORK_ACCIDENT_ID}
                              value={get(victim, [VICTIM.WORK_ACCIDENT_ID], '')}
                              onChange={handleChange(
                                VICTIM.WORK_ACCIDENT_ID,
                                index,
                              )}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, 'isWorkAccident', null),
                              )}
                              labelWidth={140}
                            >
                              {!isEmpty(
                                get(props.listings, 'workAccidents', []),
                              ) &&
                                props.listings!.workAccidents.map(type => (
                                  <MenuItem value={type.id} key={type.id}>
                                    {type.title}
                                  </MenuItem>
                                ))}
                            </StyledSelect>
                            {!props.isRecapPage &&
                              !!get(victimValidation(victim), [
                                VICTIM.WORK_ACCIDENT_ID,
                              ]) && (
                                <FormHelperText className="errorSelect">
                                  {!props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.WORK_ACCIDENT_ID
                                      ]
                                    : ''}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        {get(victim, [VICTIM.INJURY_POST_KEY], '') !== '' &&
                          !INJURY_POST.DECEASED.includes(
                            get(victim, [VICTIM.INJURY_POST_KEY], ''),
                          ) && (
                            <>
                              <Grid item xs={3} className="grid-input">
                                <FormControl
                                  fullWidth
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.ITT_AVAILABILITY,
                                        ])
                                      : false
                                  }
                                >
                                  <InputLabel
                                    ref={inputLabel}
                                    id="simple-select-outlined-label-procedure"
                                    shrink={props.inputLabelProps}
                                  >
                                    {translate(
                                      { ...messages.availabilityItt },
                                      props,
                                    )}
                                  </InputLabel>
                                  <StyledSelect
                                    name={VICTIM.ITT_AVAILABILITY}
                                    value={
                                      props.isRecapPage
                                        ? !isNil(
                                            get(victim, [VICTIM.ITT], null),
                                          ) && get(victim, [VICTIM.ITT]) !== ''
                                          ? VICTIM_ITT_AVAILABILITY.AVAILABLE
                                          : VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE
                                        : get(
                                            victim,
                                            [VICTIM.ITT_AVAILABILITY],
                                            null,
                                          )
                                    }
                                    onChange={handleChange(
                                      VICTIM.ITT_AVAILABILITY,
                                      index,
                                    )}
                                    disabled={props.disableInput}
                                  >
                                    <MenuItem
                                      value={VICTIM_ITT_AVAILABILITY.AVAILABLE}
                                      key={uniqueId()}
                                    >
                                      {translate(
                                        { ...messages.available },
                                        props,
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      value={
                                        VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE
                                      }
                                      key={uniqueId()}
                                    >
                                      {translate(
                                        { ...messages.notAvailable },
                                        props,
                                      )}
                                    </MenuItem>
                                  </StyledSelect>

                                  {!props.isRecapPage &&
                                    !!get(victimValidation(victim), [
                                      VICTIM.ITT_AVAILABILITY,
                                    ]) && (
                                      <FormHelperText className="errorSelect">
                                        {!props.isRecapPage
                                          ? errorMessage(
                                              victimValidation(victim),
                                            )[VICTIM.ITT_AVAILABILITY]
                                          : ''}
                                      </FormHelperText>
                                    )}
                                </FormControl>
                              </Grid>

                              {(get(victim, [VICTIM.ITT_AVAILABILITY]) ===
                                VICTIM_ITT_AVAILABILITY.AVAILABLE ||
                                (props.isRecapPage &&
                                  !isNil(get(victim, [VICTIM.ITT], null)) &&
                                  get(victim, [VICTIM.ITT]) !== '')) && (
                                <Grid item xs={3}>
                                  <TextField
                                    label={translate(
                                      { ...messages.ITT },
                                      props,
                                    )}
                                    type="number"
                                    disabled={props.disableInput}
                                    name={VICTIM.ITT}
                                    value={parseInt(
                                      (get(victim, [
                                        VICTIM.ITT,
                                      ]) as unknown) as string,
                                    )}
                                    onChange={handleChange(VICTIM.ITT, index)}
                                    InputLabelProps={{
                                      shrink: props.inputLabelProps,
                                    }}
                                    error={
                                      !props.isRecapPage
                                        ? !!get(victimValidation(victim), [
                                            VICTIM.ITT,
                                          ])
                                        : false
                                    }
                                    helperText={
                                      !props.isRecapPage
                                        ? errorMessage(
                                            victimValidation(victim),
                                          )[VICTIM.ITT]
                                        : ''
                                    }
                                    fullWidth
                                  ></TextField>
                                </Grid>
                              )}
                            </>
                          )}
                        <Grid item xs={3} className="grid-input">
                          <FormControl
                            fullWidth
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.OPPOSITION,
                                  ])
                                : false
                            }
                          >
                            <InputLabel
                              ref={inputLabel}
                              id="simple-select-outlined-label-work-accident"
                              shrink={props.inputLabelProps}
                            >
                              {translate(
                                { ...messages.victimOpposition },
                                props,
                              )}
                            </InputLabel>
                            <StyledSelect
                              name={VICTIM.OPPOSITION}
                              value={
                                props.readInfoSagis &&
                                !isEmpty(
                                  getVictimFromSagisInfo(
                                    get(victim, 'victimKey'),
                                    props.sagisVictimsInfo,
                                  ),
                                ) &&
                                victimIndex != index
                                  ? get(
                                      getVictimFromSagisInfo(
                                        get(victim, 'victimKey'),
                                        props.sagisVictimsInfo,
                                      ),
                                      'oppositionInd',
                                    ) === 'Y'
                                    ? 1
                                    : 0
                                  : oppositionVictimValue(victim)
                              }
                              onChange={handleChange(VICTIM.OPPOSITION, index)}
                              disabled={shouldDisableInput(
                                props.disableInput,
                                props.isCourtManagerBasicManagement,
                                get(victim, 'oppositionInd', null),
                              )}
                              labelWidth={140}
                            >
                              <MenuItem value={0} key={uniqueId('oppos_')}>
                                {translate(
                                  { ...messages.claimDeclarationNo },
                                  props,
                                )}
                              </MenuItem>
                              <MenuItem value={1} key={uniqueId()}>
                                {translate(
                                  { ...messages.claimDeclarationYes },
                                  props,
                                )}
                              </MenuItem>
                            </StyledSelect>
                            {!props.isRecapPage &&
                              !!get(victimValidation(victim), [
                                VICTIM.OPPOSITION,
                              ]) && (
                                <FormHelperText className="errorSelect">
                                  {!props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.OPPOSITION
                                      ]
                                    : ''}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <Autocomplete
                            id="standard-basic-2"
                            options={getMoroccanCities(
                              get(props.listings, 'villes', []),
                            )}
                            getOptionLabel={city => city.ItemDescription}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'Town', null),
                            )}
                            autoSelect={true}
                            onChange={handleChange(VICTIM.CITY, index)}
                            value={getCity(
                              get(props.listings, 'villes', []),
                              get(victim, [VICTIM.CITY]),
                            )}
                            filterOptions={filterOptions}
                            renderInput={params => (
                              <TextField
                                {...params}
                                name={VICTIM.CITY}
                                label={translate(
                                  { ...messages.victimCity },
                                  props,
                                )}
                                error={
                                  !props.isRecapPage
                                    ? !!get(victimValidation(victim), [
                                        VICTIM.CITY,
                                      ])
                                    : false
                                }
                                helperText={
                                  !props.isRecapPage
                                    ? errorMessage(victimValidation(victim))[
                                        VICTIM.CITY
                                      ]
                                    : ''
                                }
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <TextField
                            label={translate({ ...messages.adress }, props)}
                            InputProps={props.inputProps}
                            disabled={shouldDisableInput(
                              props.disableInput,
                              props.isCourtManagerBasicManagement,
                              get(victim, 'complement', null),
                            )}
                            name={VICTIM.ADDRESS}
                            className="input-2-3"
                            value={get(victim, [VICTIM.ADDRESS])}
                            onChange={handleChange(VICTIM.ADDRESS, index)}
                            InputLabelProps={{
                              shrink: props.inputLabelProps,
                            }}
                            error={
                              !props.isRecapPage
                                ? !!get(victimValidation(victim), [
                                    VICTIM.ADDRESS,
                                  ])
                                : false
                            }
                            helperText={
                              !props.isRecapPage
                                ? errorMessage(victimValidation(victim))[
                                    VICTIM.ADDRESS
                                  ]
                                : ''
                            }
                          ></TextField>
                        </Grid>
                        {featureService.hasFeature(FEATURES.DECEASED_VICTIMS) &&
                          INJURY_POST.DECEASED.includes(
                            get(victim, [VICTIM.INJURY_POST_KEY], ''),
                          ) && (
                            <>
                              <Grid item xs={3}>
                                <TextField
                                  type="number"
                                  label={translate(
                                    { ...messages.numberOfPartners },
                                    props,
                                  )}
                                  className="input-2-3"
                                  InputProps={{
                                    inputProps:
                                      get(victim, [VICTIM.GENDER], '') ===
                                      GENDER.FEMALE
                                        ? {
                                            ...props.inputProps,
                                            max: 1,
                                            min: 0,
                                          }
                                        : props.inputProps,
                                  }}
                                  disabled={
                                    props.disableInput ||
                                    get(victim, [VICTIM.CLASS_KEY]) ===
                                      MINOR_VALUE
                                  }
                                  name={VICTIM.NUMBER_OF_SPOUSE}
                                  value={get(victim, [VICTIM.NUMBER_OF_SPOUSE])}
                                  onChange={handleChange(
                                    VICTIM.NUMBER_OF_SPOUSE,
                                    index,
                                  )}
                                  InputLabelProps={{
                                    shrink: props.inputLabelProps,
                                  }}
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.NUMBER_OF_SPOUSE,
                                        ])
                                      : false
                                  }
                                  helperText={
                                    !props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.NUMBER_OF_SPOUSE
                                        ]
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <TextField
                                  label={translate(
                                    { ...messages.numberOfChildren },
                                    props,
                                  )}
                                  type="number"
                                  className="input-4"
                                  InputProps={props.inputProps}
                                  disabled={
                                    props.disableInput ||
                                    get(victim, [VICTIM.CLASS_KEY]) ===
                                      MINOR_VALUE
                                  }
                                  name={VICTIM.NUMBER_OF_CHILDREN}
                                  value={get(victim, [
                                    VICTIM.NUMBER_OF_CHILDREN,
                                  ])}
                                  onChange={handleChange(
                                    VICTIM.NUMBER_OF_CHILDREN,
                                    index,
                                  )}
                                  InputLabelProps={{
                                    shrink: props.inputLabelProps,
                                  }}
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.NUMBER_OF_CHILDREN,
                                        ])
                                      : false
                                  }
                                  helperText={
                                    !props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.NUMBER_OF_CHILDREN
                                        ]
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <TextField
                                  type="number"
                                  label={translate(
                                    { ...messages.numberOfDependents },
                                    props,
                                  )}
                                  className="input-4-1"
                                  InputProps={props.inputProps}
                                  disabled={
                                    props.disableInput ||
                                    get(victim, [VICTIM.CLASS_KEY]) ===
                                      MINOR_VALUE
                                  }
                                  name={VICTIM.NUMBER_OF_DEPENDENTS}
                                  value={get(victim, [
                                    VICTIM.NUMBER_OF_DEPENDENTS,
                                  ])}
                                  onChange={handleChange(
                                    VICTIM.NUMBER_OF_DEPENDENTS,
                                    index,
                                  )}
                                  InputLabelProps={{
                                    shrink: props.inputLabelProps,
                                  }}
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.NUMBER_OF_DEPENDENTS,
                                        ])
                                      : false
                                  }
                                  helperText={
                                    !props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.NUMBER_OF_DEPENDENTS
                                        ]
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <TextField
                                  label={translate(
                                    { ...messages.annualOfIncome },
                                    props,
                                  )}
                                  type="number"
                                  className="input-4-1"
                                  InputProps={props.inputProps}
                                  disabled={props.disableInput}
                                  name={VICTIM.ANNUAL_INCOME}
                                  value={get(victim, [VICTIM.ANNUAL_INCOME])}
                                  onChange={handleChange(
                                    VICTIM.ANNUAL_INCOME,
                                    index,
                                  )}
                                  InputLabelProps={{
                                    shrink: props.inputLabelProps,
                                  }}
                                  error={
                                    !props.isRecapPage
                                      ? !!get(victimValidation(victim), [
                                          VICTIM.ANNUAL_INCOME,
                                        ])
                                      : false
                                  }
                                  helperText={
                                    !props.isRecapPage
                                      ? errorMessage(victimValidation(victim))[
                                          VICTIM.ANNUAL_INCOME
                                        ]
                                      : ''
                                  }
                                />
                              </Grid>
                            </>
                          )}
                      </Grid>
                      {/* deceased victims */}
                      {featureService.hasFeature(FEATURES.DECEASED_VICTIMS) &&
                        INJURY_POST.DECEASED.includes(
                          get(victim, [VICTIM.INJURY_POST_KEY], ''),
                        ) && (
                          <div className="deceaseBlock">
                            <Typography className="text deceased-title">
                              {translate(
                                { ...messages.vitimDeceasedTitle },
                                props,
                              )}
                              {displayButtonAddBeneficiary(
                                props.isRecapPage,
                                props.isOpeningManager,
                                props.isLawyer,
                                isRejected,
                                props.isLockedPage,
                                props.isCourtManager,
                                isValidated,
                                props.isCourtManagerBasicManagement,
                                isValidatedCorpo,
                              ) && (
                                <PrimaryButton
                                  data-testid="add_beneficiary_btn"
                                  className="add-beneficiary-btn"
                                  onClick={() => openFormBeneficiary()}
                                  title={translate(
                                    { ...messages.addBeneficiaryBtn },
                                    props,
                                  )}
                                />
                              )}
                            </Typography>

                            {victim.beneficiaries &&
                              victim.beneficiaries.map(
                                (
                                  beneficiary: BeneficiaryType,
                                  beneficiary_index: number,
                                ) => (
                                  <div
                                    key={beneficiary_index}
                                    className="beneficiary"
                                  >
                                    <BeneficiaryAccordion
                                      listing={props.listings}
                                      beneficiary={beneficiary}
                                      index={beneficiary_index}
                                      isDrawer={false}
                                      inputProps={props.inputProps}
                                      disableInput={
                                        props.isCourtManagerBasicManagement
                                          ? get(
                                              saveBeneficiaryState,
                                              [beneficiary_index],
                                              false,
                                            )
                                          : true
                                      }
                                      inputLabelProps={props.inputLabelProps}
                                      editButtonTitle={displayEditBeneficiaryButton(
                                        props.isRecapPage,
                                        props.isManager,
                                        props.isReadOnly,
                                        value,
                                        isRejected,
                                        props.isLawyer,
                                        props.isCourtManager,
                                        isValidatedCorpo,
                                        props.isOpeningManager,
                                        isValidated,
                                        translate(
                                          {
                                            ...messages.updateBtnLabel,
                                          },
                                          props,
                                        ),
                                      )}
                                      handleBeneficiaryChange={handleBeneficiaryChange(
                                        index,
                                        beneficiary_index,
                                      )}
                                      handleSubmitEdit={handleSubmitBeneficiaryEdit(
                                        index,
                                        beneficiary_index,
                                      )}
                                      couldDelete={
                                        shouldDisplayEditButton(
                                          props.isRecapPage,
                                          props.isManager,
                                          props.isReadOnly,
                                          value,
                                          isRejected,
                                          props.isLawyer,
                                          props.isCourtManager,
                                        ) &&
                                        !isValidatedCorpo &&
                                        (isValidated && props.isOpeningManager
                                          ? featureService.hasFeature(
                                              FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                                            )
                                          : true) &&
                                        (props.isCourtManager
                                          ? featureService.hasFeature(
                                              FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                                            )
                                          : true)
                                      }
                                      isCourtMonitoringManagerUpdate={
                                        isCourtMonitoringManager ||
                                        (featureService.hasFeature(
                                          FEATURES.UPDATE_VICTIM_BASIC_MANAGEMENT,
                                        ) &&
                                          isCourtManager)
                                      }
                                      handleDelete={handleDelete(
                                        index,
                                        beneficiary_index,
                                      )}
                                      victim={victim}
                                      lossDate={get(
                                        claimToPreopen,
                                        'claim.lossDate',
                                      )}
                                    />
                                  </div>
                                ),
                              )}

                            {openBeneficiaryForm && (
                              <BeneficiaryAccordion
                                listing={props.listings}
                                isDrawer={false}
                                isOpeningManager={props.isOpeningManager}
                                beneficiary={
                                  {
                                    [BENEFICIARY.DEPENDENT_INDICATOR]: true,
                                  } as any
                                }
                                // index={beneficiary_index}
                                inputProps={props.inputProps}
                                disableInput={props.disableInput}
                                inputLabelProps={props.inputLabelProps}
                                handleBeneficiaryChange={saveBeneficiary(index)}
                                handleCancel={closeFormBeneficiary}
                                victim={victim}
                                isCourtManagerBasicManagement={
                                  props.isCourtManagerBasicManagement
                                }
                                isLawyer={props.isLawyer}
                                isRejected={isRejected}
                                isCourtManager={props.isCourtManager}
                                lossDate={get(claimToPreopen, 'claim.lossDate')}
                              />
                            )}
                          </div>
                        )}
                      {/*End deceased victims*/}
                      <div className="checkdiv">
                        <Typography className="text">
                          {translate({ ...messages.excludeVictim }, props)}
                        </Typography>
                        <FormControl>
                          <RadioGroup
                            row
                            onChange={handleChange(VICTIM.IS_EXCLUDED, index)}
                            value={isExcludedValue(
                              get(victim, [VICTIM.IS_EXCLUDED], ''),
                            )}
                          >
                            <FormControlLabel
                              control={
                                <Radio
                                  color="primary"
                                  value={CHOICE.YES}
                                  checkedIcon={<CheckCircle />}
                                  icon={<RadioButtonUnchecked />}
                                  disabled={props.disableInput}
                                />
                              }
                              label={translate({ ...messages.yes }, props)}
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  color="primary"
                                  value={CHOICE.NO}
                                  checkedIcon={<CheckCircle />}
                                  icon={<RadioButtonUnchecked />}
                                  disabled={props.disableInput}
                                />
                              }
                              label={translate({ ...messages.no }, props)}
                            />
                          </RadioGroup>
                          {!props.isRecapPage &&
                            !!get(victimValidation(victim), [
                              VICTIM.IS_EXCLUDED,
                            ]) && (
                              <FormHelperText className="error">
                                {!props.isRecapPage
                                  ? errorMessage(victimValidation(victim))[
                                      VICTIM.IS_EXCLUDED
                                    ]
                                  : ''}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </div>
                    </div>
                  </SahamAccordion>
                </div>
              );
            })}
          </div>

          {!props.isRecapPage && shouldAddVictim() && (
            <div>
              <div className="add-victim-container">
                <div className="iconDiv">
                  <div className="icon">
                    <AddVctim />
                  </div>
                </div>
                <PrimaryButton
                  className="add-viction-btn"
                  onClick={addVictim}
                  title={translate({ ...messages.addVictimBtn }, props)}
                />
              </div>
            </div>
          )}
          {showButtonConfirmEligibiltyTransaction && (
            <div>
              <div className="add-eligibility-victim">
                <PrimaryButton
                  className="add-eligibilty-btn"
                  background={BUTTON_COLORS.PRIMARY_BLUE}
                  titlecolor={COLORS.WHITE}
                  border={BUTTON_COLORS.PRIMARY_BLUE}
                  onClick={handleConfirmEligibiltyTransaction}
                  title={translate(messages.confirmButtonTitle, props)}
                  disabled={isAllVictimFulledEligibility(
                    removeDeletedItems([
                      ...(!isEmpty(get(props.dataClaimToUpdate, 'victims', []))
                        ? get(props.dataClaimToUpdate, 'victims', [])
                        : victims),
                    ]),
                    victimsEligibleToTransaction,
                  )}
                />
              </div>
            </div>
          )}
        </CardContent>
      </Card>
      {isModificationDrawerOpen && (
        <VictimDrawer
          open={isModificationDrawerOpen}
          handleToggleDrawer={handleToggleModificationDrawer}
          index={isNull(victimIndex) ? 0 : (victimIndex as any)}
          listings={props.listings}
          data={value}
          requestUpdateVictimInfo={props.requestUpdateVictimInfo}
          setClaimRecap={props.setClaimRecap}
          isCourtMonitoringManagerUpdate={
            isCourtMonitoringManager ||
            ((featureService.hasFeature(
              FEATURES.UPDATE_VICTIM_BASIC_MANAGEMENT,
            ) ||
              featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)) &&
              isCourtManager)
          }
          isCourtManager={isCourtManager}
          closeVictimDrawer={closeVictimDrawer}
          policyInfo={props.policyInfo}
          setDataClaimToUpdate={props.setDataClaimToUpdate}
          dataClaimToUpdate={props.dataClaimToUpdate}
        />
      )}
      {openDrawerAdd && (
        <AddVictimDrawer
          victimFormValues={victimAddFormValues}
          setVictimFormValues={setVictimAddFormValues}
          addVictimForm={addVictimCardForm}
          claimId={get(value, 'claim.id', '')}
          listings={props.listings}
          open={openDrawerAdd}
          handleToggleDrawer={handleToggleDrawerAddVictim}
          requestCreateVictim={props.requestCreateVictim}
          dataClaimToUpdate={props.dataClaimToUpdate}
          setDataClaimToUpdate={props.setDataClaimToUpdate}
          isOpeningManager={props.isOpeningManager}
          setClaimRecap={props.setClaimRecap}
          claimRecap={props.storedClaimToPreopen}
          isDrawerAdd={true}
        />
      )}
      {openDecisionPartiesDialog && (
        <DecisionPartiesDialog
          open={openDecisionPartiesDialog}
          onClose={() => {
            setOpenDecisionPartiesDialog(false);
            setSelectVictim({});
          }}
          policyInfo={props.policyInfo}
          parties={selectedVictim}
          requestValidateVictim={props.requestValidateVictim}
          isVehicle={false}
          victims={victims}
          listings={props.listings}
          claimInfo={get(value, 'claim')}
        />
      )}
      {isAddVictimsDialogOpen && (
        <DialogCivilProceeding
          open={isAddVictimsDialogOpen}
          title={translate(messages.addVictimBtn, props)}
          handleClose={() => setIsAddVictimsDialogOpen(false)}
          confirmTitle={translate(messages.add, props)}
          cancelTitle={translate(messages.cancelBtn, props)}
          handleValidate={validateAddVictim}
          disablePrimaryButton={
            !isUniqueCinAddedVictims(
              get(props.storedClaimToPreopen, 'victims', []),
              (Object.values(newVictimsAddedValues) as unknown) as VictimType[],
              get(props.storedClaimToPreopen, 'claim.lossDate'),
            ) ||
            checkClassVictims(
              [...Object.values(newVictimsAddedValues)],
              get(props.storedClaimToPreopen, 'claim.lossDate'),
            ) ||
            checkVictimsAge(
              [...Object.values(newVictimsAddedValues)],
              get(props.storedClaimToPreopen, 'claim.lossDate'),
            )
          }
          children={
            <VictimFormComponent
              victimFormValues={newVictimsAddedValues}
              setVictimFormValues={setNewVictimsAddedValues}
              addVictimForm={addNewVictimCard}
              claimId={get(value, 'claim.id', '')}
              listings={props.listings}
              victimValidation={newVictimValidation}
              isRejected={isRejected}
              isLawyer={props.isLawyer}
              isCourtManager={props.isCourtManager}
              claimRecap={props.storedClaimToPreopen}
            />
          }
        />
      )}
      {isTransactionDrawerOpen && (
        <AddTransactionDrawer
          open={isTransactionDrawerOpen}
          handleToggleDrawer={handleToggleTransactionDrawer}
          index={isNull(victimIndex) ? 0 : (victimIndex as any)}
          listings={props.listings}
          data={value}
          dataClaimToUpdate={props.dataClaimToUpdate}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadedDocument={props.uploadedDocument}
          uploadDocument={props.uploadDocument}
          requestAddTransaction={props.requestAddTransaction}
          victimInfo={getVictimInfoById(
            props.policyInfo,
            get(props.storedClaimToPreopen, `victims[${victimIndex}].id`),
          )}
          scaleCaseInfo={get(props.storedClaimToPreopen, 'claim')}
          policyInfo={props.policyInfo}
          claimNumber={get(props.storedClaimToPreopen, 'claim.claimNumber')}
          claimId={get(props.storedClaimToPreopen, 'claim.id')}
          victimValidation={victimValidationState}
          setVictimValidation={setVictimValidationState}
          claimVictims={get(props.storedClaimToPreopen, 'victims', [])}
          receptionDate={null as any}
          transactionInfo={([] as unknown) as TransactionType}
          dahirAmounts={[]}
        />
      )}
      {isOpenConfirmTransactionDialog && (
        <ConfirmDialog
          open={isOpenConfirmTransactionDialog}
          handleClose={() => setIsOpenConfirmTransactionDialog(false)}
          title={translate(messages.transactionDialogEligibilityTitle, props)}
          children={
            <>
              {translate(messages.transactionDialogEligibleDescription, props)}
            </>
          }
          confirmTitle={translate(messages.confirmButtonTitle, props)}
          cancelTitle={translate(messages.cancelButtonTitle, props)}
          disablePrimaryButton={false}
          handleValidate={handleValidateEligibility(get(value, 'claim.id', ''))}
        />
      )}
      <EligibilityTransactionDialog
        open={openEligibilityTransactionDialog}
        onClose={() => setOpenEligibilityTransactionDialog(false)}
        eligible={eligible}
        setEligible={setEligible}
        handleValidate={handleValidateEligibilityDialog}
        reason={reason}
        setReason={setReason}
      />
    </VictimContainer>
  );
};
export default injectIntl(VictimCard);
